export const INT_TIPO_USUARIO_ADMINISTRADOR_WEB = 2;
export const INT_TIPO_SUB_USUARIO_WEB = 3;

export const INT_QUERY_UPDATE = 1;
export const INT_QUERY_DELETE = 0;

export const PIE_DE_PAGINA = {
    INPUT_LABEL: 27,
    INPUT_LINEA_VACIA: 28,
    FIRMA: 33,
};